import { render, staticRenderFns } from "./RequestsTable.vue?vue&type=template&id=1e84fb12&scoped=true"
import script from "./RequestsTable.vue?vue&type=script&lang=js"
export * from "./RequestsTable.vue?vue&type=script&lang=js"
import style0 from "./RequestsTable.vue?vue&type=style&index=0&id=1e84fb12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e84fb12",
  null
  
)

export default component.exports